import { Fragment } from "react";
import { Col, Row, Button, Form, FormGroup, Label, Input } from "reactstrap";
import { Link } from "react-router-dom";
// Layout

import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { setLoginFieldAction } from "../../../reducers/ui/login";
import { hasEmptyValue, showWarning } from "../../../utils/service";
import { apiLoginUserAction } from "../../../sagas/apiCallSaga";

const mapStateToProps = (store) => ({
  state: store.ui.login,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      setField: setLoginFieldAction,
      loginUser: apiLoginUserAction,
    },
    dispatch
  );

class LoginBoxed extends Component {
  btnLoginClicked = () => {
    let { email, password } = this.props.state.loginCredential;

    if (hasEmptyValue([email, password])) {
      showWarning("There are missing fields");
      return;
    }

    this.props.loginUser({
      email,
      password,
    });
  };

  render() {
    let { loginCredential } = this.props.state;
    let { setField } = this.props;

    return (
      <Fragment>
        <div className="modal-dialog w-100 mx-auto">
          <div className="modal-content">
            <div className="modal-body">
              <div className="h5 modal-title text-center">
                <h4 className="mt-2">
                  <div>Welcome back,</div>
                  <span>Please sign in to your account below.</span>
                </h4>
              </div>
              <Form>
                <Row form>
                  <Col md={12}>
                    <FormGroup>
                      <Input
                        type="email"
                        placeholder="Email here..."
                        value={loginCredential.email || ""}
                        onChange={(e) => setField("email", e.target.value)}
                      />
                    </FormGroup>
                  </Col>
                  <Col md={12}>
                    <FormGroup>
                      <Input
                        type="password"
                        placeholder="Password here..."
                        value={loginCredential.password || ""}
                        onChange={(e) => setField("password", e.target.value)}
                      />
                    </FormGroup>
                  </Col>
                </Row>
                <FormGroup check>
                  <Input type="checkbox" name="check" id="exampleCheck" />
                  <Label for="exampleCheck" check>
                    Keep me logged in
                  </Label>
                </FormGroup>
              </Form>
              <div className="divider" />
              <h6 className="mb-0">
                No account?{" "}
                <Link to="/pages/register-boxed" className="text-primary">
                  Sign up now
                </Link>
              </h6>
            </div>
            <div className="modal-footer clearfix">
              <div className="float-left">
                <Link to="/pages/forgot-password-boxed">Recover Password</Link>
              </div>
              <div className="float-right">
                <Button
                  color="primary"
                  size="lg"
                  onClick={this.btnLoginClicked}
                >
                  Login
                </Button>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(LoginBoxed);
